var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container mt-4"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-11"},[(_vm.focusDiagItem)?_c('NodeContentViewer',{attrs:{"body":_vm.focusDiagItem.body}}):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }